import { toDate } from "@/utils/time";

export { money, toMs } from "@/dashboard/format";

export { toDate };

export function euro(value) {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(value) || 0);
}

export function shortDate(value) {
  const date = toDate(value);
  if (!date) return "";
  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleDateString("fr-FR", { day: "numeric", month: "short", ...(sameYear ? {} : { year: "numeric" }) });
}

export function partyName(details = {}) {
  return [details.firstName, details.lastName].filter(Boolean).join(" ") || details.name || "";
}
